<template>
    <div v-if="show" class="reg-pop relative">

        <div class="login-pop-title cf">

            <div class="fl">找回密码</div>

        </div>

        <div class="login-input login-margin cf">

            <img class="fl login-input-icon" src="./images/login_icon_user@2x.png" />

            <input class="fl" type="text" v-model="mobile" placeholder="请输入手机号码" />

        </div>

        <div class="reg-code login-margin cf">

            <img class="fl login-input-icon" src="./images/register_icon_verify@2x.png" />

            <input class="fl" type="number" v-model="code" placeholder="请输入验证码" />

            <div
                class="fr code-btn button-active pointer"
                :style="{ color: disabled ? '#8F5FF5' : '#999999' }"
                @click="getCode"
            >{{ codeText }}</div>

        </div>

        <div class="login-input login-margin cf">

            <img class="fl login-input-icon" src="./images/login_icon_code@2x.png" />

            <input class="fl" :type="input_type1 ? 'password' : 'text'" v-model="password" placeholder="请设置登录密码" />

            <div class="eye fr" @click="input_type1 = !input_type1">

                <img v-if="input_type1" src="./images/sign_ico_eye_closed@2x.png" />

                <img v-else src="./images/sign_ico_eye_opened@2x.png" />

            </div>

        </div>

        <div class="login-input login-margin cf">

            <img class="fl login-input-icon" src="./images/login_icon_code@2x.png" />

            <input class="fl" :type="input_type2 ? 'password' : 'text'" v-model="reg_password" placeholder="请再次输入密码" />

            <div class="eye fr" @click="input_type2 = !input_type2">

                <img v-if="input_type2" src="./images/sign_ico_eye_closed@2x.png" />

                <img v-else src="./images/sign_ico_eye_opened@2x.png" />

            </div>

        </div>

        <div class="login-btn button button-active" @click="changePassword">确认修改</div>

        <img
            class="close-pop absolute button-active"
            src="./images/sign_ico_closed@2x.png"
            @click.stop="close"
        />

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "layout-forget",
    mixins: [mixin],
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped src="./style.css"></style>
